import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardSvgComponent } from './dashboard-svg.component';

@NgModule({
  declarations: [
    DashboardSvgComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    DashboardSvgComponent
  ]
})
export class DashboardSvgModule { }
